import React from 'react';
import {
  IconUser,
  IconUtensils,
  IconMotorcycle,
  IconIdCardFilled,
  IconHelpFilled,
  IconLogout,
  IconSquareMenu,
} from 'takeat-design-system-ui-kit';

export const MENU_OBJECT = (user, logoutFunction) => ({
  profile: {
    name: user.fantasy_name,
    image: user.avatar?.url,
    text: 'Perfil',
    path: '/profile',
    icon: <IconUser />,
    displayType: 'page',
    subitems: [
      { text: 'Editar meu negócio', path: '/info' },
      { text: 'Alterar perfil da conta', path: '/user-profile' },
      { text: 'Tarefas', path: '/tasks' },
    ],
  },
  categories: [
    {
      text: 'Operação',
      path: '/operation',
      icon: <IconUtensils />,
      displayType: 'sidebar',
      condition: !user.only_delivery,
      subitems: [
        {
          text: 'Mesa / Balcão',
          path: '',
          condition: !user.only_delivery,
        },
        {
          text: 'Caixa',
          path: '/opening-box',
        },
        {
          text: 'Comandas',
          path: '/bills',
          condition: !user.only_delivery,
        },
        {
          text: 'KDS',
          path: '/kds',
        },
      ],
    },
    {
      text: 'Delivery',
      path: '/delivery',
      icon: <IconMotorcycle />,
      condition: user.delivery_info.is_delivery_allowed,
      subitems: [
        {
          text: 'Pedidos',
          path: '/orders',
          displayType: 'sidebar',
        },
        {
          text: 'Caixa',
          path: '/opening-box',
          condition: user.only_delivery,
          displayType: 'sidebar',
        },
        {
          text: 'Horário de funcionamento',
          path: '/opening-hours',
          displayType: 'page',
        },
        {
          text: 'Endereços',
          path: '/addresses',
          displayType: 'page',
        },
        {
          text: 'Agendamento',
          path: '/scheduling',
          displayType: 'page',
        },
        {
          text: 'Cupons',
          path: '/coupons',
          displayType: 'page',
        },
        {
          text: 'Motoboys',
          path: '/motoboys',
          displayType: 'page',
        },
        {
          text: 'Configurações',
          path: '/config',
        },
      ],
    },
    {
      text: 'Cadastros',
      path: '/register',
      icon: <IconIdCardFilled />,
      subitems: [
        {
          text: 'Cardápio',
          path: '/menu',
        },
        {
          text: 'Estoque',
          path: '/stock',
          displayType: 'sidebar',
        },
        {
          text: 'Vinculos iFood ',
          path: '/ifood',
          condition: user.has_ifood,
        },
        {
          text: 'Vinculos Fiscais',
          path: '/fiscal',
          condition: user.has_nfce,
        },
        {
          text: 'Vinculos 99Food ',
          path: '/99food',
          condition: user.has_99food,
        },
        {
          text: 'Garçons',
          path: '/waiters',
          displayType: 'page',
        },
        {
          text: 'Usuários',
          path: '/users',
          displayType: 'page',
        },
        {
          text: 'Impressoras e outros',
          path: '/printers',
          displayType: 'page',
        },
        {
          text: 'Mesas e Comandas',
          path: '/tables',
          displayType: 'page',
        },
        {
          text: 'Produtos por código de barras EAN',
          path: '/ean-code-relation',
          displayType: 'page',
        },
        {
          text: 'Contas a prazo',
          path: '/credit-register',
          condition: user.credit_register_enabled,
        },
        {
          text: 'Histórico de transferência de Itens',
          path: '/transfer-items',
          displayType: 'page',
        },
        {
          text: 'Balanças',
          path: '/balances',
          displayType: 'page',
          condition: user.use_balance,
        },
        {
          text: 'Maquininhas POS',
          path: '/stone-devices',
          displayType: 'page',
          condition: user.has_stone_pos,
        },
      ],
    },

    {
      text: 'Ver mais',
      path: '/search',
      icon: <IconSquareMenu />,
      displayType: 'sidebar',
    },

    {
      text: 'Fiscal',
      path: '/fiscal',
      displayType: 'page',
      condition: user.has_nfce,
      subitems: [
        { text: 'Manifesto de Notas', path: '/manifest' },
        { text: 'Entrada de Notas', path: '/entries' },
        { text: 'Notas Emitidas', path: '/issued' },
        { text: 'Notas Devolvidas', path: '/returned' },
        { text: 'Grupos fiscais', path: '/groups' },
      ],
    },
    {
      text: 'Estoque',
      path: '/register/stock',
      displayType: 'page',
      subitems: [
        { text: 'Insumos', path: '' },
        {
          text: 'Transferência de Estoque',
          path: '/transfers',
          condition: user.is_distribution_center,
        },
        { text: 'Fornecedores', path: '/suppliers' },
      ],
    },
    {
      text: 'Perfil',
      path: '/profile',
      displayType: 'page',
      subitems: [
        { text: 'Editar meu negócio', path: '/info' },
        { text: 'Alterar perfil da conta', path: '/user-profile' },
        { text: 'Tarefas', path: '/tasks' },
      ],
    },
    {
      text: 'Ajuda',
      path: '/help',
      icon: <IconHelpFilled />,
      displayType: 'sidebar',
      barPosition: 'footer',
    },
    {
      text: 'Sair',
      icon: <IconLogout />,
      displayType: 'sidebar',
      barPosition: 'footer',
      function: logoutFunction,
    },
  ],
});
